import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/activities';

const apiFindActivitiesByAreaId = async (areaId)=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/area/${areaId}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiCreateNewActivity = async (req)=> new Promise((resolve, reject)=> axiosConsumer().put(`${resource}/create`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiUpdateExistingActivity = async (req)=> new Promise((resolve, reject)=> axiosConsumer().patch(`${resource}/edit`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiLogicDeleteActivityById = async (id)=> new Promise((resolve, reject)=> axiosConsumer().delete(`${resource}/${id}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const ActivityRepository = {
  findByAreaId: apiFindActivitiesByAreaId,
  create: apiCreateNewActivity,
  update: apiUpdateExistingActivity,
  deleteById: apiLogicDeleteActivityById
};